<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="account__section help">
    <ul class="help__actions">
      <HelpAction v-for="(action, index) in helpActions"
        :key="index"
        :icon="action.icon"
        :text="action.text"
        :href="action.href"
        :hasCaret="hasCaret"
        :show="action.show"
      />
    </ul>
  </div>
</template>

<script>
import HelpAction from './HelpActions.vue'
import { env } from '../../../utils/env'

export default {
  components: {
    HelpAction
  },
  props: {
    hasCaret: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isKenya () {
      return env.country === 'KENYA'
    },
    emailLink () {
      const user = this.$store.getters.user
      const userAgent = navigator.userAgent
      const ip = this.$store.getters['dataNotifier/userinfo']
        ? this.$store.getters['dataNotifier/userinfo'].ip
        : 'n/a'
      const env = this.env
      const payload = {
        subject: encodeURIComponent('I am experiencing an issue on Mobile'),
        body: encodeURIComponent(`
          Customer Details:
          Phone Number: ${user.mobile},
          User Agent: ${userAgent},
          IP: ${ip},
          Country: ${env.country}

          Issue Description:

          **Type your issue here**
        `)
      }

      const supportEmail = this.env.supportEmail

      return (
        'mailto:' +
        `${supportEmail}?` +
        Object.keys(payload).reduce((acc, curr) => {
          if (acc === '') return `${curr}=${payload[curr]}`
          return `${acc}&${curr}=${payload[curr]}`
        }, '')
      )
    },
    helpActions () {
      return [
        {
          icon: 'HelpCenterIcon',
          text: this.$t('overlay-menu.visit-help-center'),
          href: env.helpLink,
          show: env.helpLink && !this.isKenya
        },
        {
          icon: 'TelephoneIcon',
          text: this.$t('overlay-menu.call-customer-service'),
          href: `tel:${env.supportNumber}`,
          show: true
        },
        {
          icon: 'WhatsAppIcon',
          text: this.$t('overlay-menu.whatsapp'),
          href: env.whatsappInformation.link,
          show: env.whatsappInformation.link && env.whatsappInformation.link.number
        },
        {
          icon: 'EmailIcon',
          text: this.$t('overlay-menu.contact-support'),
          href: this.emailLink,
          show: true
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.help {
  &__actions {
    list-style: none;
    padding-inline-start: 0;
    margin: 0;

    li a:last-child {
      padding: 10px 0;
      margin-bottom: 0;
      font-size: var(--font-large);
    }
  }
}
</style>
